<template>
    <el-dialog
        :title="title"
        :visible.sync="isVisible"
        :close-on-click-modal="false"
        width="40%"
        @close="_onDialogClose"
    >
        <el-form
            ref="form"
            :rules="rules"
            :model="form"
            label-position="top"
            @submit.native.prevent="_send"
        >
            <el-form-item
                label="Название"
                prop="title"
            >
                <el-input v-model="form.title" />
            </el-form-item>

            <el-form-item
                label="Описание"
                prop="description"
            >
                <el-input
                    v-model="form.description"
                    type="textarea"
                    :rows="3"
                />
            </el-form-item>

            <div style="display: flex; justify-content: space-between;">
                <el-button
                    type="primary"
                    @click="_send"
                >
                    {{ buttonText }}
                </el-button>

                <el-button
                    type="default"
                    @click="_cancel"
                >
                    Отмена
                </el-button>
            </div>
        </el-form>
    </el-dialog>
</template>

<script>
import _ from 'lodash';
import { Location as LocationApi } from '@/api';
import showError from '@/utils/showError';

export default {
    name: 'LocationFormPopup',

    data() {
        return {
            isVisible: false,
            form: {},
            locationToEdit: null
        };
    },

    computed: {
        isEditMode() {
            return !!this.locationId;
        },

        title() {
            return this.isEditMode
                ? `Редактирование места "${this.form.title || ''}"`
                : 'Добавление места проведения';
        },

        buttonText() {
            return this.isEditMode ? 'Сохранить' : 'Добавить';
        },

        locationId() {
            return _.get(this, 'locationToEdit.id');
        },

        rules() {
            return {
                title: [
                    {
                        required: true,
                        message: 'Название места проведения обязательно'
                    }
                ]
            };
        }
    },

    methods: {
        open(location = null) {
            this.locationToEdit = location;
            this.form = {
                ..._.get(location, 'attributes', {})
            };
            this.isVisible = true;
        },

        close() {
            this.isVisible = false;
        },

        _onDialogClose() {
            this._resetForm();
        },

        _send() {
            this.$refs.form.validate()
                .then(this._doSend.bind(this))
                .catch(showError('Проверьте форму'));
        },

        _doSend() {
            const data = {
                title: this.form.title,
                description: this.form.description
            };
            const request = this.isEditMode
                ? LocationApi.update({ id: this.locationId, ...data })
                    .then(location => this.$emit('updated', { location }))
                    .catch(showError('Не удалось обновить место проведения'))
                : LocationApi.store(data)
                    .then(location => this.$emit('added', { location }))
                    .catch(showError('Не удалось создать место проведения'));

            request.then(() => this.close());
        },

        _cancel() {
            this.close();
        },

        _resetForm() {
            this.locationToEdit = null;
            this.form = {};
        }
    }
};
</script>
